import { Component, EventEmitter, Output } from "@angular/core";
import { LocationUrl } from "src/app/constants/url/location.url";
import { ResponseDto } from "src/app/dto/common/response.dto";
import { PointDto } from "src/app/dto/location/point.dto";
import { AccountService } from "src/app/service/account/account.service";
import { HttpService } from "src/app/service/http/http.service";

@Component({
    selector: 'location',
    templateUrl: '../../view/location/location.html'
})
export class LocationComponent {
    public pointDtoList: PointDto[] = [];

    @Output() public addBookmarkEvent: EventEmitter<PointDto> = new EventEmitter<PointDto>();
    @Output() public locationClickEvent: EventEmitter<PointDto> = new EventEmitter<PointDto>();
    @Output() public closeEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(private httpService: HttpService, private accountService: AccountService) {}

    ngAfterViewInit() {
        this.getList();
    }

    public add(locationDto: {}): void {
        this.httpService.post<ResponseDto<void>>(LocationUrl.add, locationDto)
            .subscribe(response => {
                if (response.isSuccess) {
                    this.getList();
                }
            });
    }

    public getList(): void {
        this.httpService.get<ResponseDto<PointDto[]>>(LocationUrl.get(this.accountService.getAccountSeq()))
            .subscribe(response => {
                if (response.isSuccess) {
                    this.pointDtoList = [];
                    response.data.forEach(location => {
                        this.pointDtoList.push(Object.assign(new PointDto(), location));
                    });
                }
            });
    }

    public delete(locationSeq: number): void {
        this.httpService.delete<ResponseDto<void>>(LocationUrl.delete(locationSeq))
            .subscribe(response => {
                if (response.isSuccess) {
                    this.getList();
                }
            });
    }

    public deleteAll(): void {
        this.httpService.delete<ResponseDto<void>>(LocationUrl.deleteAll(this.accountService.getAccountSeq()))
            .subscribe(response => {
                if (response.isSuccess) {
                    this.pointDtoList = [];
                }
            });
    }

    public addBookmark(pointDto: PointDto): void {
        pointDto.seq = 0;
        
        this.addBookmarkEvent.emit(pointDto);
    }

    public search(pointDto: PointDto): void {
        this.add(pointDto.toLocationDto());

        this.locationClickEvent.emit(pointDto);
        this.close();
    }

    public close(): void {
        this.closeEvent.emit();
    }
}